<template>

  <t-page>

    <t-dialog-duplicate v-if="formDuplicateShow" :origin="formDuplicate.origin" :path-server="currentPage.path" :form-error="formDuplicateError" v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onFlowDuplicated">

      <template #default="{status}">
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowId" hidden />
        <t-input label="Nome do novo Fluxo de Processos" :status="status" :add-error="formDuplicateError.name" v-model="formDuplicate.changeName" required />
      </template>
    </t-dialog-duplicate>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">

          <t-list-link-primary :label="item.name" :userAuth="userAuth" :id="item.processFlowNumber"
                               :path="currentPage.path"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)="{item}">

          <t-list-actions-default :form-path="currentPage.path" :id="item.processFlowNumber" :userAuth="userAuth">
            <b-button @click="openDialogDuplicate(item.processFlowId, item.name)" v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500 title="Duplicar processo"><b-icon-files variant="primary" /></b-button>
          </t-list-actions-default>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components:{TDialogDuplicate},
  name: 'ProcessFlow',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Fluxo de Processo"},
        {key: "groupsProduct", label: "Grupos Produtos"},
        {key: "models", label: "Modelos"},
        {key: "materials", label: "Materiais"},
        {key: "units", label: "Embalagens"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      formDuplicateShow:false,
      formDuplicate:{
        processFlowId:0,
        changeName:"",
        origin:"",
      },
      formDuplicateError:{
        name:"",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {



    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'production-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openDialogDuplicate(id,origin){

      this.formDuplicateShow = true
      this.formDuplicate.processFlowId = id
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = ""

      this.openDialogForm('modal-duplicate')

    },

    onFlowDuplicated(item){

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicado", "Novo fluxo <b>" + item.name + "</b> duplicado com sucesso!", "success", "b-toaster-top-center", true)

      this.getPage(this.pageNumber)
    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
